// extracted by mini-css-extract-plugin
export default {"loader":"circularprogress_loader__BSs6t","rotation":"circularprogress_rotation__nM8BL"};